import { Fragment } from 'react';
import { useIsKeyHeld } from './useIsKeyHeld';
import styles from './VisuallyHidden.module.scss';

type Props = {
  /**
   * Something that gives extra information to screen reader users.
   * This is often text, but can be any type of ReactNode.
   */
  children?: React.ReactNode;
};

/**
 * A visually hidden component that aids in giving extra context to screen reader users.
 */
export const VisuallyHidden = (props: Props) => {
  const isAltKeyHeld = useIsKeyHeld('Alt');
  if (isAltKeyHeld) {
    return <Fragment>{props.children}</Fragment>;
  }
  return (
    <span className={styles.visuallyHidden} data-testid="visually-hidden">
      {props.children}
    </span>
  );
};
